import Vue from 'vue'
import Store from './vuex/store.js'
import VueLocalStorage from 'vue-localstorage'
import VueGtm from 'vue-gtm';
import Router from './router'
import App from './App.vue'
import VueLazyload from 'vue-lazyload'
import it from 'date-fns/locale/it'
import format from 'date-fns/format'
import VueMeta from 'vue-meta'
import Utilities from './utilities'
import Config from './config'
import AOS from 'aos'
import 'aos/dist/aos.css'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

Vue.config.productionTip = false
window.eventBus = new Vue() //catch events from api.js

Vue.use(VueLocalStorage)
Vue.use(VueLazyload, {})
Vue.mixin(Utilities);
Vue.mixin(Config);

Vue.filter('trim', function (value) {
  if (!value) return ''
  return value.trim()
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('uppercase', function (value) {
  if (!value) return ''
  return value = value.toString().toUpperCase()
})
Vue.filter('lowercase', function (value) {
  if (!value) return ''
  return value = value.toString().toLowerCase()
})
Vue.filter('formatDate', function (value) {
  if (!value) return ''
  return value = format(value, 'DD/MM/YYYY', {locale: it})
})

Store.subscribe((mutation, state) => {
  Vue.localStorage.set(process.env.VUE_APP_STORE_KEY, JSON.stringify(state))
})

Vue.use(VueGtm, {
  id: process.env.VUE_APP_TAG_MANAGER, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  /*queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
    gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
    gtm_preview:'env-4',
    gtm_cookies_win:'x'
  },*/
  enabled: (process.env.VUE_APP_TAG_MANAGER_ENABLED == 'true'), // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: (process.env.VUE_APP_DEBUG == 'true'), // Whether or not display console logs debugs (optional)
  loadScript: (process.env.VUE_APP_TAG_MANAGER_ENABLED == 'true'), // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: Router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [] // If router, you can exclude some routes name (case insensitive) (optional)
});


Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
})


new Vue({
  router: Router,
  el: '#app',
  store: Store,
  mixins: [
    Utilities,
    Config
  ],
  render: h => h(App),
  // Full VUE component lifecycle:
  beforeCreate () {
    //window.console.log('Vue: beforeCreate()');
    Vue.prototype.$config = {}
  },
  created () {
    //window.console.log('Vue: created()');
    AOS.init()
  },
  beforeMount () {
    //window.console.log('Vue: beforeMount()');
  },
  mounted () {
    //window.console.log('Vue: mounted()');
  },
  beforeUpdate() {
    //window.console.log('Vue: beforeUpdate()');
  },
  update () {
    //window.console.log('Vue: update()');
  },
  beforeDestroy () {
    //window.console.log('Vue: beforeDestroy()');
  },
  destroyed () {
    //window.console.log('Vue: destroyed()');
  }
})